// Store listings for the Paiper Customer app, shared by every "get the app" surface.
export const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/paiperclips/id6738892162';
export const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.paiperclips&hl=en_US&pli=1';
